import React from 'react'
import DonateForm from './DonateForm'
import PageHeader from '../components/PageHeader';

const DonationPage = () => {
  return (
    <>
                <PageHeader title="देणगी तपशील" path="/donate" name="donate" />
                <DonateForm/> 
              
    </>
  )
}

export default DonationPage